/**
 * Predicate functions: pure `(args) => boolean` helpers with no side effects.
 * Anything returning a value other than a boolean does not belong in this file.
 */
import { IS_ENABLED_KEY } from '../constants';

/**
 * Whether a robot status signal counts as failing. A signal fails when it is a
 * boolean set to `false`, except `is_enabled` — a disabled device is not a failure.
 * @param   {String}  name  Signal name (e.g. metric key or top-level flag).
 * @param   {*}       value Signal value.
 * @return  {Boolean}       True if the signal is a failure.
 */
export const isFailingSignal = (name, value) =>
  typeof value === 'boolean' && name !== IS_ENABLED_KEY && value === false;

/**
 * Whether a robot status signal marks a disabled device (`is_enabled === false`).
 * @param   {String}  name  Signal name.
 * @param   {*}       value Signal value.
 * @return  {Boolean}       True if the signal marks a disabled device.
 */
export const isDisabledSignal = (name, value) =>
  name === IS_ENABLED_KEY && value === false;